module.exports = __webpack_public_path__ + "img/HSZHSY_Android.14565bd9.png";